import {css} from "@emotion/react";

import {pb} from "@pg-design/helpers-css";
import {p} from "@pg-design/helpers-css/";
import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

export const OfferDetailOpinionsSuccess = () => {
    return (
        <div css={wrapper} data-testid={OFFER_TEST_IDS.OFFER_VIEW.RATE_OFFER_SECTION_SUMMARY}>
            <div css={iconWrap}>
                <BrandCheckboxCheckedIcon size="9" wrapperSize="9.6" wrapperType="circle" wrapperColor={getThemeVariable("colors.primary")} />
            </div>
            <Text variant="headline_4" align="center">
                Dziękujemy za Twoją opinię
            </Text>
        </div>
    );
};

const wrapper = css`
    ${p(3)}
    padding: 2.4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const iconWrap = css`
    ${pb(3)};
`;
import {css} from "@emotion/react";

import {pb} from "@pg-design/helpers-css";
import {p} from "@pg-design/helpers-css/";
import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

export const OfferDetailOpinionsSuccess = () => {
    return (
        <div css={wrapper} data-testid={OFFER_TEST_IDS.OFFER_VIEW.RATE_OFFER_SECTION_SUMMARY}>
            <div css={iconWrap}>
                <BrandCheckboxCheckedIcon size="9" wrapperSize="9.6" wrapperType="circle" wrapperColor={getThemeVariable("colors.primary")} />
            </div>
            <Text variant="headline_4" align="center">
                Dziękujemy za Twoją opinię
            </Text>
        </div>
    );
};

const wrapper = css`
    ${p(3)}
    padding: 2.4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const iconWrap = css`
    ${pb(3)};
`;
